import { LocaleCode } from 'src/app/interfaces/locale'

export const serviceKo = [
  {
    title: '제1조(목적)',
    desc: '타입스(Types) 서비스 이용 약관은 우트㈜ (이하 회사)가 타입스 서비스 내 다양한 맞춤 서비스를 제공함에 있어, 회사와 회원 간의 권리, 의무 및 책임 사항 등을 규정함을 목적으로 합니다.',
  },
  {
    title: '제2조(정의)',
    desc: '1. "회사"란 서비스를 제공하는 주체를 말합니다. \
          \n2. "서비스"란, 회사가 제공하는 성향 퀴즈, 퀴즈 결과, 케미 분석 외 프로필 등 회사가 제공하는 서비스 일체를 말합니다. 서비스는 정보통신설비를 이용하여 재화 및 용역을 거래할 수 있도록 설정한 가상의 영업장을 포함합니다. 서비스는 각 서비스 내부에서 보여지는 게시물, 기능, 재화, 용역 등을 모두 포함하며, 이와 관련된 사항과 정보 또한 모두 포함합니다.\
          \n3. "회원"이란, 회사가 제공하는 서비스에 접속하여 본 약관을 동의하고 가입한 후 서비스를 제공받는 자를 말합니다.\
          \n4. “아이디"란, 회원의 식별과 서비스 이용을 위하여 회원이 정하고 회사가 승인하는 문자 또는 문자와 숫자의 조합을 의미합니다.\
          \n5. “프로필”이란 회원이 서비스 내에서 활동하기 위해 만든 프로필로, 카카오톡 서비스의 프로필 이미지가 포함됩니다. \
          \n6. "성격 유형 퀴즈"란, 회원이 서비스를 이용함에 있어 서비스에서 제공되는 성격 유형에 관한 질문과 응답 일체를 의미합니다. \
          \n7. “친구 등록”이란 타입스 서비스를 이용하고 있는 다른 회원을 카카오톡 연락처 기반으로 등록하는 것을 의미합니다. \
          \n8. "약정"이란, 구매, 판매, 공급, 지급, 제작, 중개, 중계, 당첨 등 서비스 내부에서 회사와 회원 사이에 발생한 계약, 서약, 약속 등을 말합니다.\
          \n9. “코인”이란 본 서비스의 유료 서비스를 이용하기 위한 가상 화폐를 뜻합니다. \
          \n10.“유료 서비스”란 회사가 유료로 제공하는 각종 디지털 콘텐츠 및 제반 서비스를 의미합니다. \
          \n11. “구매”란 회원이 회사에서 제공하는 결제 수단을 통해 현금을 코인으로 전환하는 행위를 의미합니다.',
  },
  {
    title: '제3조(약관의 게시와 개정)',
    desc: '1. 회사는 회사의 모든 약관과 법령에 따라 명시해야 하는 정보가 있을 경우, 서비스 하단, 더보기, 프로필, 그 외 기타 메뉴, 팝업, 배너 등에 게시할 수 있습니다.\
          \n2. 회사는 관련법을 위배하지 않는 범위에서 본 약관을 개정할 수 있습니다.\
          \n3. 만약 개정내용이 회원에게 불리한 경우, 적용 일자 30일 이전부터 적용 일자 전일까지 우트 앱 서비스 내에서 확인할 수 있는 공지사항에 공지합니다.\
          \n4. 회사가 제2항에 따라 개정 약관을 공지한 후, 회원이 30일 이내에 명시적으로 거부 의사 표시를 하지 않은 경우 회원이 개정 약관에 동의한 것으로 간주합니다.\
          \n5. 회원이 개정약관의 적용에 동의하지 않는 경우, 회원은 이용계약을 해지함으로써 거부 의사를 표시할 수 있습니다.\
          \n6. 회사는 유료 서비스 및 개별 서비스에 대해서는 별도의 이용약관 및 정책을 둘 수 있으며, 해당 내용이 이 약관과 상충할 경우에는 본 약관이 우선 적용됩니다.\
          \n7. 회원은 약관 일부분만을 동의 또는 거부할 수 없습니다.\
          \n8. 본 약관의 일부가 집행 불능으로 판단되더라도 나머지 부분은 계속해서 효력을 갖습니다.',
  },
  {
    title: '제4조(서비스 이용 계약 등)',
    desc: '1. 회원이 되고자 하는 자는 회사가 정한 가입 양식에 따라 회원 정보를 입력하고 각 약관을 동의한 후 가입 버튼을 누르는 방법으로 회원 가입을 신청합니다.\
          \n2. 회원가입신청의 성립은 가입 신청자가 가입 신청완료한 시점으로 합니다.\
          \n3. 다만, 다음 각호에 해당하는 경우, 별도의 통보 없이 회원가입을 거부하거나 이용 계약을 해지할 수 있습니다.\
          \n- 각 약관을 준수하지 않거나 각 약관에 의해 가입 신청자가 회원 자격을 상실한 적이 있을 경우\
          \n- 기타 회원으로 등록하는 것이 부적절하다고 판단되는 경우\
          \n4. 회사는 필요시 부정사용방지 및 본인확인을 위해 제휴기관을 통한 실명확인 및 본인인증을 요청할 수 있습니다.\
          \n5. 회사는 회원이 서비스를 이용하는 도중, 연속하여 1년 동안 서비스를 이용하기 위해 로그인 기록이 없는 경우 회원자격을 박탈할 수 있습니다.',
  },
  {
    title: '제5조(회원의 의무)',
    desc: '1. 회원이 서비스를 이용하는 것은 회원이 적용 가능한 모든 법률, 규범 및 규정을 준수함에 동의하는 것입니다. 또한 회원은 서비스 이용을 규정하는 특정 추가 규범(이하 행동 규범)을 준수함에 동의합니다. 행동 규범은 모든 내용을 담고 있는 것은 아니며, 회사는 특정 행동이 금지 목록에 있는지에 관계없이 서비스의 완전함과 속성을 보호하기 위해 (회원에게 통지하고) 환불, 영구 정지를 포함한 적합한 징계조치를 취할 수 있음은 물론 언제라도 이 행동 규범을 수정할 권한을 보유합니다. 이러한 행동 규범 외에도, 모범적인 서비스 이용행동 및 제재조치들에 대한 자세한 안내는 서비스 내에 공지된 회원 규율 및 운영정책을 참고하십시오. 다음은 제재 조치가 따르는 행동의 예시를 나열한 것으로 이에 국한되지 않습니다.\
          \n- 신청 또는 변경 시 허위 기재, 기재 누락, 오기, 도용 행위\
          \n- 회사 및 제3자의 명예를 손상시키거나 업무를 방해하는 행위\
          \n- 회사의 모든 재산에 대한 침해 행위\
          \n- 회사의 서비스 이외의 허가하지 않은 행위\
          \n- 회사의 직원 또는 서비스 관리자를 사칭하는 행위\
          \n- 서비스 내 게시물 및 자료를 허가 없이 이용, 변조, 삭제 및 외부로 유출하는 행위\
          \n- 타인의 개인정보 및 계정을 수집, 저장, 공개, 이용하거나 자신과 타인의 개인정보를 제3자에게 공개, 양도하는 행위\
          \n- 다중 계정을 생성 및 이용하는 행위\
          \n- 허가되지 않은 상업적 행위\
          \n- 타입스 개인정보처리방침 등 회원이 동의한 모든 약관에 대해 따르지 않는 행위\
          \n- 현행법에 어긋나거나 서비스 제공에 있어 부적절하다고 판단되는 행위\
          \n2. 회사는 이용자가 본 조 제2항의 금지행위를 한 경우 본 약관 제 18조에 따라 서비스 이용 제한 조치를 취할 수 있습니다.\
          \n3. 회원은 회원가입신청을 한 시점의 정보와 현재의 정보가 다를 경우 즉시 변경사항을 정정해야 합니다.\
          \n4. 회사의 서비스관련설비와 관련된 기술상 또는 업무상 문제가 있는 경우에 승낙이 유보될 수 있습니다.\
          \n5. 회사가 관계 법령 및 각 약관에 의해서 책임을 지는 경우를 제외하고, 자신의 개인정보에 관한 관리책임은 각 회원에게 있으므로, 부정 사용되지 않도록 관리해야 합니다.\
          \n6. 회원은 아이디 및 비밀번호가 도용되거나 제3자가 사용하고 있음을 인지한 경우 이를 즉시 회사에 통지하고, 회사의 안내에 따라야 합니다.\
          \n7. 제4항의 경우에 해당 회원이 회사에 그 사실을 통지하지 않거나, 통지한 경우에도 회사의 안내에 따르지 않아 발생한 불이익에 대하여 회사는 책임지지 않습니다.\
          \n8. 회사는 회원의 아이디가 개인정보 유출 우려가 있거나, 반사회적 또는 미풍양속에 어긋나거나 회사 및 회사의 운영자로 오인될 우려가 있는 경우, 해당 아이디의 이용을 제한할 수 있습니다.\
          \n9. 회원은 서비스를 이용함에 있어 회사의 각 약관을 준수하지 않거나 의무를 다하지 않아 회사나 다른 회원이 손해를 입을 경우, 그 손해를 배상할 책임이 있습니다.',
  },
  {
    title: '제6조(회원정보의 변경)',
    desc: '1. 회원은 서비스내 "프로필”을 통하여 언제든지 본인의 개인정보를 열람하고 수정할 수 있습니다. 다만, 서비스 관리를 위해 필요한 단말기 식별번호 (디바이스 아이디 또는 IMEI), 전화번호, 아이디(이메일 주소) 등은 수정이 불가능합니다.\
          \n2. 회사는 서비스관련설비와 관련해 기술상 또는 업무상 문제로 프로필이 바로 변경되지 않을 수 있으며 이로 발생한 불이익에 대하여 회사는 책임지지 않습니다.',
  },
  {
    title: '제7조(회원에 대한 통지 등)',
    desc: '1. 회사가 특정 회원에 대해 통지를 하는 경우, 회원의 개인정보와 서비스 내부 수단을 사용할 수 있습니다.\
          \n2. 회원 전체에 대한 통지의 경우, 공지사항에 게시함으로써 제1항의 통지에 대신할 수 있습니다.\
          \n3. 회원이 30일 이내에 의사 표시를 하지 않은 경우, 회원이 통지 내용에 대해 동의한 것으로 간주합니다.',
  },
  {
    title: '제8조(서비스 및 약정의 제공, 변경, 중단, 철회)',
    desc: '1. 회사는 회사가 자체 개발하거나 다른 회사와의 협력을 통해 회원들에게 제공할 일체의 서비스를 제공합니다.\
          \n2.회원은 서비스에서 제공하는 기능을 이용하여 재화 및 용역을 구매하거나, 이벤트 등에 참여할 때, 회신, 서명, 버튼을 누르는 방식 등으로 동의 의사를 표현하여 약정을 체결할 수 있습니다.\
          \n3.서비스를 이용하거나 약정을 체결할 경우, 서비스를 이용하거나 약정을 체결하기까지 명시된 모든 내용에 동의한 것으로 봅니다.\
          \n4. 회원은 서비스에서 재화 및 용역을 구매할 경우, 결제대금예치 등 구매 시점에 서비스에 명시되어 있는 방법을 이용하여 대금을 지급할 수 있습니다.\
          \n5. 회사는 별도의 약정이 없을 경우, 재화 및 용역을 최대 14일 이내에 공급할 수 있습니다.\
          \n6. 회사는 운영상, 기술상의 필요에 따라 제공하고 있는 서비스를 변경할 수 있습니다.\
          \n7. 회사는 점검, 고장, 교체, 변경, 품절 등의 불가피한 사유가 발생한 경우, 서비스 및 약정을 일시적 및 영구적으로 보류 및 중단할 수 있으며, 약정의 내용을 대체하거나 회원의 동의에 따라 약정을 파기할 수 있습니다. 회원이 회사에 대금을 지급한 약정이 파기될 경우, 회사는 파기 시점으로부터 5영업일 이내에 지급받은 대금을 환급합니다.\
          \n8. 서비스 변경 및 중단의 경우에는 제6조에서 정한 방법을 통해 통지합니다.다만 회사가 통제할 수 없는 사유로 서비스가 중단되어 통지가 불가능한 경우에는 통지하지 않습니다.',
  },
  {
    title: '제9조(회사의 의무)',
    desc: '1. 회사는 법령과 본 약관이 금지하거나 공서양속에 반하는 행위를 하지 않습니다.\
          \n2. 회사는 안정적, 지속적이고 편리한 서비스를 제공하기 위해 노력합니다.',
  },
  {
    title: '제10조(저작권의 귀속)',
    desc: '1. 회사가 작성한 게시물에 대한 권리는 회사에게 귀속됩니다. 그러므로 회원은 서비스를 이용함으로써 얻은 정보를 회사의 사전 승낙 없이 임의로 복제, 전송, 출판, 배포 등 영리 목적으로 이용하거나 제3자에게 제공할 수 없습니다.\
          \n2.회원이 작성한 게시물에 대한 권리는 회원에게 귀속됩니다.단, 회사는 서비스의 운영, 확장, 홍보 등의 필요한 목적으로 회원의 저작물을 합리적이고 필요한 범위 내에서 별도의 허락 없이 수정하여 무상으로 사용하거나 제휴사에게 제공할 수 있습니다.이 경우, 개인정보는 절대 제공하지 않습니다.\
          \n3. 회사는 제2항 이외의 방법으로 회원의 게시물을 이용할 경우, 회원의 개인정보와 서비스 내부 수단을 이용하여 회원의 동의를 받아야 합니다.',
  },
  {
    title: '제11조(서비스의 관리)',
    desc: '1. 회원이 관련법 및 각 약관에 위배되는 내용의 활동을 할 경우, 회사는 해당 서비스, 게시물을 임의로 삭제, 중단, 변경 등의 조치를 할 수 있고 회원의 자격 및 권한을 제한, 정지 및 박탈할 수 있습니다.\
          \n2. 회원의 게시물로 인한 법률상 이익 침해를 근거로, 다른 회원 또는 제3자가 회원 또는 회사를 대상으로 하여 민형사상의 법적 조치를 취하거나 관련된 게시물의 삭제를 요청하는 경우, 회사는 관련 게시물에 대한 접근을 잠정적으로 제한할 수 있습니다.',
  },
  {
    title: '제12조(광고의 게재 및 발신)',
    desc: '1. 회사가 회원에게 서비스를 제공할 수 있는 투자기반의 일부는 광고게재를 통한 수익에서 나옵니다. 회사는 회원이 등록한 게시물이나 그 내용을 활용한 광고게재 및 기타 서비스를 이용하면서 노출되는 광고를 게재할 수 있습니다.\
          \n2. 회사는 회원이 광고성 정보 수신에 동의할 경우, 이메일, 푸시 알림, 1:1 대화, 문자 메시지 등 전자적 매체를 이용하여 광고성 정보를 발신할 수 있습니다.',
  },
  {
    title: '제13조 유료서비스의 내용 등의 표시',
    desc: '1.  회사는 다음 사항을 유료서비스의 이용 초기화면이나 코인 구매화면에서 사용자가 알기 쉽게 표시합니다.\
          \n- 유료서비스의 명칭 또는 제호 \
          \n- 유료서비스의 내용, 이용방법, 이용료, 기타조건 \
          \n2. 회사의 유료서비스의 이용가능기기 및 이용에 필요한 최소한의 기술사항은 권장사양정보에 따릅니다. \
          \n3. 회사는 유료 유료서비스를 제공함에 있어 유료서비스의 교환, 반품, 보증과 그 대금 환불의 조건 및 절차에 관한 사항을 제공합니다. \
          \n4. 유료서비스 이용을 위한 코인 구매의 철회는 앱스토어와 구글플레이스토어를 통한 환불 요청을 통해 가능합니다.',
  },
  {
    title: '제14조 코인의 사용 및 소멸',
    desc: '1. 코인이란 서비스에서 사용할 수 있는 화폐단위입니다. 회원은 보유한 코인을 사용해 서비스 내에 유료 서비스를 구매할 수 있습니다. \
          \n2. 본인의 계정을 삭제하거나 회원의 귀책 사유로 서비스 계정이 삭제되는 경우 해당 계정에서 구매된 코인은 자동으로 소멸됩니다. \
          \n3. 회원의 귀책 사유로 인한 서비스 계정 이용 제한의 경우에는 해당 제한 기간 동안 코인을 사용할 수 없습니다. \
          \n4. 코인 획득에 문제가 있을 경우 여러분은 문제 발생 시점으로부터 30일 이내에 회사에 정정 신청을 할 수 있으며, 회사는 해당 신청일로부터 30일 이내에 조정할 수 있습니다. \
          \n5. 코인의 사용 순서는 회사가 정한 정책에 따릅니다. ',
  },
  {
    title: '제15조(이용계약 해지)',
    desc: '1. 회원은 언제든지 “탈퇴”를 통해 이용계약 해지 신청을 할 수 있으며, 회사는 관련법 등이 정하는 바에 따라 이를 즉시 처리하여야 합니다.\
          \n2. 회원이 이용계약을 해지할 경우, 관련법 및 타입스 개인정보처리방침에 따라 모든 개인정보가 처리됩니다.\
          \n3. 회원이 이용계약을 해지한 뒤 새로 가입한 경우, 해지한 계정의 게시물 권한 등 모든 권리는 이양되지 않습니다.',
  },
  {
    title: '제16조(이용 제한 등)',
    desc: '1. 회사는 회원이 이 약관의 의무를 위반하거나 서비스의 정상적인 운영을 방해한 경우, 주의, 경고, 일시정지, 영구이용정지, 계약해지 등의 조치를 즉시 취할 수 있으며, 회원은 법적책임을 부담합니다.\
          \n2. 회사는 “주민등록법”을 위반한 명의도용 및 결제도용, 전화번호 도용, “저작권법”을 위반한 불법프로그램의 제공 및 운영방해, 정보통신망, "정보통신망 이용촉진 및 정보보호 등에 관한 법률"을 위반한 불법통신 및 해킹, 악성프로그램의 배포, 접속권한 초과행위, “여신전문금융업법”을 위반한 “이용자”의 신용카드 부정거래 등 이와 유사한 형태의 부정행위 등과 같이 관련법을 위반한 경우에는 주의, 경고, 일시정지, 영구이용정지, 계약해지 등의 조치를 즉시 취할 수 있으며, 회원은 법적책임을 부담할 수 있습니다.\
          \n3. 회사는 회원이 계속해서 1년 이상 로그인하지 않는 경우, 회원정보의 보호 및 운영의 효율성을 위해 이용을 제한할 수 있습니다.\
          \n4. 본 조의 이용제한 범위 내에서 제한의 조건 및 세부내용은 회사의 이용제한정책에서 정하는 바에 의합니다.\
          \n5. 본 조에 따라 서비스 이용을 제한하거나 계약을 해지하는 경우에는 회사는 제7조에 따라 통지합니다.\
          \n6. 회원은 본 조에 따른 이용제한 등에 대해 회사가 정한 절차에 따라 이의신청을 할 수 있습니다. 이 때 이의가 정당하다고 회사가 인정하는 경우 회사는 즉시 서비스의 이용을 재개합니다.\
          \n7. 본 조에 따라 이용제한이 되는 경우 서비스 이용을 통해 획득한 혜택 등도 모두 이용중단, 또는 소멸되며, 회사는 이에 대해 별도로 보상하지 않습니다.',
  },
  {
    title: '제17조(책임제한)',
    desc: '1. 회사는 다음의 경우, 어떠한 경우라도 책임을 지거나 보상을 하지 않으며, 회원에게 귀책사유가 있을 경우, 별도의 통보 없이 자격을 제한, 정지 및 박탈할 수 있습니다.\
          \n- 천재지변 또는 이에 준하는 불가항력으로 인하여 서비스를 제공할 수 없는 경우\
          \n- 회사가 무료로 제공하는 서비스가 변경, 중단되거나 장애가 생길 경우\
          \n- 회사가 고의·과실이 없음을 입증할 경우\
          \n- 회사에서 판매하는 제품의 가격이 권장소비자가격의 90%보다 낮은 가격 오류일 경우\
          \n- 회원의 작성한 게시물에 대한 정보, 자료, 신뢰도, 정확성 등에 대해\
          \n- 회원 간이나 회원과 광고주 등 제3자 상호 간에 합의한 거래 등에 대해\
          \n- 회원이 서비스를 이용함에 있어 회사의 각 약관을 준수하지 않거나 의무를 다하지 않을 경우\
          \n2. 회사는 제1항 외 귀책사유로 인하여 재화 및 용역을 구매한 회원에게 법률적으로 인과관계를 밝힐 수 있는 손해가 발생하는 경우에는 그 손해를 배상할 책임이 있습니다.',
  },
  {
    title: '제18조(분쟁해결)',
    desc: '1. 회사는 회원이 제기하는 문의, 정당한 의견 및 불만을 반영 및 처리하고 그 피해를 보상 처리하기 위하여 피해보상처리기구를 설치 및 운영합니다.\
          \n2. 회사와 회원 간에 발생한 전자상거래 분쟁과 관련하여 회원의 피해구제신청이 있는 경우에는 공정거래위원회 또는 시 도지사가 의뢰하는 분쟁조정기관의 조정에 따를 수 있습니다.',
  },
  {
    title: '제19조(재판관할)',
    desc: '1. 회사와 회원 간 제기된 소송은 대한민국법을 준거법으로 하며, 관할 법원에 제소합니다.\
          \n2. 회사와 회원 간 발생한 분쟁에 관한 소송은 제소 당시 회원의 주소에 의하고, 주소가 없는 경우 거소를 관할하는 지방법원의 전속관할로 합니다. 단, 제소 당시 회원의 주소 또는 거소가 명확하지 아니한 경우의 관할법원은 민사소송법에 따라 정합니다.\
          \n3. 해외에 주소나 거소가 있는 회원의 경우, 회사와 회원간 발생한 분쟁에 관한 소송은 전항에도 불구하고 대한민국 서울중앙지방법원을 관할 법원으로 합니다.',
  },
  {
    title: '제20조(부칙)',
    desc: '- 이 약관은 2023년 11월 06일부터 적용됩니다.\
          \n- 이 약관은 타 약관보다 우선하며, 이 약관 제2조의 정의는 모든 약관에 적용됩니다.\
          \n- 회사가 직접 제공하는 타입스 사이트 이외에 링크된 사이트에서는 모든 약관이 적용되지 않습니다.\
          \n- 이 약관에 명시되어 있지 않은 사항은 관련 법령을 따릅니다',
  },
]

export const serviceEn = [
  {
    title: 'Article 1 (Purpose)',
    desc: 'The purpose of the Types Service Terms of Use (hereinafter referred to as the "Terms") is to regulate the rights, obligations, and responsibilities between Ute Co., Ltd. (hereinafter referred to as the "Company") and members regarding the various customized services provided within the Types service.',
  },
  {
    title: 'Article 2 (Definitions)',
    desc: '1. "Company" refers to the entity providing the service.\
    \n2. "Service" refers to all services provided by the Company, including personality quizzes, quiz results, chemistry analyses, and profiles. It encompasses virtual business premises established to facilitate transactions of goods and services using information and communication facilities. The service also includes all content, features, goods, services, and related information.\
    \n3. "Member" refers to an individual who accesses and agrees to these Terms and joins the service provided by the Company.\
    \n4. "ID" refers to a combination of characters or a combination of characters and numbers determined by a member and approved by the Company for identification and service use.\
    \n5. "Profile" refers to the profile created by a member to engage in activities within the service, including the profile image from KakaoTalk.\
    \n6. "Personality Type Quiz" refers to all questions and responses regarding personality types provided by the service for member use.\
    \n7. "Friend Registration" refers to registering other members using KakaoTalk contacts within the Types service.\
    \n8. "Agreement" refers to contracts, agreements, or promises made between the Company and members within the service, including purchases, sales, supplies, payments, production, mediation, and prizes.\
    \n9. "Coin" refers to virtual currency used for paid services within this service.\
    \n10. "Paid Service" refers to various digital contents and services provided by the Company for a fee.\
    \n11. "Purchase" refers to the act of a member converting cash into coins using the payment methods provided by the Company.\
    ',
  },
  {
    title: 'Article 3 (Publication and Amendment of the Terms)',
    desc: '1. The Company may publish all terms and information that must be specified according to all terms and laws at the bottom of the service, in the More menu, profiles, and other menus, pop-ups, or banners.\
    \n2. The Company may amend these Terms within the scope not violating related laws.\
    \n3. If the amended content is disadvantageous to members, the Company shall announce it in the Notices section within the Ute App service from 30 days before the application date until the day before the application date.\
    \n4. After announcing the amended terms according to clause 2, if the member does not explicitly express refusal within 30 days, it is considered that the member has agreed to the amended terms.\
    \n5. If a member does not agree to the application of the amended terms, they may express refusal by terminating the service agreement.\
    \n6. The Company may establish separate terms and policies for paid services and individual services, and in case of conflicts with these Terms, these Terms shall prevail.\
    \n7. Members cannot agree or disagree with only a part of these Terms.\
    \n8. Even if a part of these Terms is deemed unenforceable, the remaining parts shall remain in effect.\
    ',
  },
  {
    title: 'Article 4 (Service Use Agreement, etc.)',
    desc: '1. Individuals who wish to become members shall apply for membership by entering member information according to the prescribed application form provided by the Company and agreeing to each term before clicking the registration button.\
    \n2. The completion of membership application is deemed to have occurred when the applicant completes the registration process.\
    \n3. However, the Company may refuse membership or terminate the service agreement without prior notice if any of the following apply:\
     \n - If the applicant has lost membership qualifications due to non-compliance with each term or due to the terms.\
     \n - If it is deemed inappropriate to register as a member for any other reason.\
    \n4. The Company may request real-name verification and identity authentication through affiliated agencies if necessary for preventing misuse and verifying identity.\
    \n5. If a member does not log in for one year while using the service, the Company may revoke the membership.\
    ',
  },
  {
    title: "Article 5 (Member's Obligations)",
    desc: `1. The use of the service by members constitutes agreement to comply with all applicable laws, norms, and regulations. Additionally, members agree to abide by specific additional regulations (hereinafter referred to as "Behavioral Guidelines") that govern service use. The Behavioral Guidelines may not cover all content, and the Company reserves the right to modify them at any time to protect the integrity and nature of the service (notifying members) and to take appropriate disciplinary actions, including refunds and permanent suspensions, regardless of whether specific behaviors are listed as prohibited.
      2. In addition to these Behavioral Guidelines, please refer to the member regulations and operational policies posted within the service for detailed guidance on exemplary service use behaviors and disciplinary measures. The following are examples of behaviors that may result in sanctions, but this list is not exhaustive:
        - Providing false information, omissions, deception, or identity theft when applying or modifying
        - Actions that damage the reputation of the company or third parties or disrupt business operations
        - Infringement upon all property of the company
        - Unauthorized activities outside of the company's services
        - Impersonating company employees or service administrators
        - Unauthorized use, alteration, deletion, or disclosure of postings and data within the service
        - Collecting, storing, disclosing, or using personal information of others or oneself and disclosing or transferring such information to third parties
        - Creating and using multiple accounts
        - Unauthorized commercial activities
        - Actions that violate the Types Privacy Policy or any other terms agreed upon by members
        - Behaviors deemed inappropriate or in violation of current laws in providing services
      3. If a user engages in prohibited actions under paragraph 2 of this Article, the Company may take measures to restrict service use in accordance with Article 18 of these Terms.
      4. Members must promptly correct any discrepancies in information from the time of application for membership.
      5. Approval may be withheld if there are technical or business issues related to the company's service facilities.
      6. Except in cases where the company is responsible under relevant laws and each agreement, each member is responsible for managing their personal information to prevent misuse.
      7. If a member becomes aware that their ID and password have been stolen or used by a third party, they must immediately notify the company and follow the company's instructions.
      8. In cases under paragraph 4, the company shall not be liable for any disadvantages incurred if the member fails to notify the company of such facts or does not follow the company's instructions even after notification.
      9. If there is a risk of personal information leakage, anti-social behavior, or misunderstanding as a company or company operator due to a member's ID, the company may restrict the use of that ID.
    `,
  },
  {
    title: 'Article 6 (Change of Member Information)',
    desc: `1. Members may view and modify their personal information at any time through the "Profile" within the service. However, terminal identification numbers (device IDs or IMEIs), phone numbers, and IDs (email addresses) necessary for service management cannot be modified.
      2. The company is not responsible for immediate changes to profiles due to technical or business issues related to service facilities.
    `,
  },
  {
    title: 'Article 7 (Notification to Members)',
    desc: `1. When the company notifies specific members, it may use the member's personal information and internal service tools.
      2. For notifications to all members, the company may post them in the Notices section instead of using the method described in paragraph 1.
      3. If a member does not express their intention within 30 days, it is considered that the member has agreed to the notification content.
    `,
  },
  {
    title: 'Article 8 (Provision, Modification, Suspension, and Withdrawal of Service and Agreement)',
    desc: `1. The company provides all services to members developed internally or provided through collaboration with other companies.
      2. Members may enter into agreements by expressing consent through methods such as replies, signatures, or button clicks when purchasing goods or services or participating in events using the features provided in the service.
      3. By using the service or entering into agreements, members are deemed to have agreed to all specified contents before using the service or entering into agreements.
      4. When purchasing goods or services through the service, members may pay the price using the methods specified in the service at the time of purchase.
      5. The company may supply goods or services within a maximum of 14 days unless otherwise agreed.
      6. The company may change the services provided according to operational or technical needs.
      7. In the event of unavoidable circumstances such as inspection, malfunction, replacement, modification, or out-of-stock, the company may temporarily or permanently suspend services and agreements and replace the agreement or terminate the agreement with the member's consent. If an agreement for which the member has paid is terminated, the company will refund the payment within 5 business days from the termination date.
      8. Notice of service changes and suspensions will be made in accordance with the method specified in Article 6. However, if the service is suspended due to circumstances beyond the company's control and notification is impossible, no notification will be made.
    `,
  },
  {
    title: "Article 9 (Company's Obligations)",
    desc: `1. The Company shall not engage in acts prohibited by laws and these Terms, or acts contrary to public order and morals.
      2. The Company shall strive to provide stable, continuous, and convenient services.
    `,
  },
  {
    title: 'Article 10 (Ownership of Copyright)',
    desc: `1. The rights to postings created by the Company belong to the Company. Members may not replicate, transmit, publish, distribute, or provide to third parties for commercial purposes the information obtained by using the service without prior consent from the Company.
      2. The rights to postings created by members belong to the members. However, for the operation, expansion, and promotion of the service, the Company may, within a reasonable and necessary scope, modify and use the members' works without separate permission or provide them to affiliates free of charge. In this case, personal information will not be provided.
      3. If the Company uses a member's postings in a manner other than stated in paragraph 2, the Company must obtain the member's consent using the member's personal information and internal service tools.
    `,
  },
  {
    title: 'Article 11 (Management of the Service)',
    desc: `1. If a member engages in activities that violate relevant laws and each agreement, the Company may take measures such as deleting, suspending, or modifying the relevant service or postings at its discretion, and restrict, suspend, or revoke the member's qualifications and rights.
      2. If another member or a third party takes legal action against a member or the Company or requests the deletion of relevant postings based on infringement of legal interests caused by a member's postings, the Company may temporarily restrict access to the relevant postings.
    `,
  },
  {
    title: 'Article 12 (Publication and Transmission of Advertisements)',
    desc: `1. Some of the investment bases for providing services to members are derived from advertising revenue. The Company may publish advertisements on the service using members' postings or their content and other services.
      2. If members agree to receive advertising information, the Company may transmit advertising information via electronic media such as email, push notifications, one-on-one conversations, and text messages.
    `,
  },
  {
    title: 'Article 13 (Indication of the Contents of Paid Services)',
    desc: `1. The Company shall clearly display the following items on the initial screen for using paid services or the coin purchase screen so that users can easily understand:
      2. Name or title of the paid service
      3. Content, method of use, fee, and other conditions of the paid service
      4. The minimum technical specifications required for using the Company's paid services are based on the recommended specifications information.
      5. The Company provides information on the conditions and procedures for exchanges, returns, guarantees, and refunds of paid services.
      6. Withdrawal of coin purchases for using paid services is possible through refund requests via the App Store and Google Play Store.
    `,
  },
  {
    title: 'Article 14 (Use and Expiry of Coins)',
    desc: `1. Coins are the currency units that can be used in the service. Members can use the coins they possess to purchase paid services within the service.
      2. If a member deletes their own account or the service account is deleted due to the member's fault, the coins purchased on that account will automatically expire.
      3. In case of service account restrictions due to the member's fault, coins cannot be used during the restriction period.
      4. If there is an issue with acquiring coins, you can request a correction from the company within 30 days from the occurrence of the issue, and the company may adjust it within 30 days from the date of the request.
      5. The order of using coins follows the policies set by the company.
    `,
  },
  {
    title: 'Article 15 (Termination of Service Agreement)',
    desc: `1. Members may request termination of the service agreement at any time through "Withdrawal," and the Company must promptly process it in accordance with relevant laws.
      2. Upon termination of the service agreement by a member, all personal information shall be processed in accordance with relevant laws and the Types Privacy Policy.
      3. If a member re-registers after terminating the service agreement, all rights, including posting permissions of the terminated account, are not transferred.
    `,
  },
  {
    title: 'Article 16 (Restriction of Use, etc.)',
    desc: `1. If a member violates the obligations under these Terms or disrupts the normal operation of the service, the Company may take immediate measures such as caution, warning, temporary suspension, permanent suspension, or termination of the contract, and the member shall bear legal responsibility.
      2. In cases where a member violates related laws, such as identity theft and payment fraud, illegal programs, illegal communication, hacking, and similar fraudulent acts, the Company may take immediate measures such as caution, warning, temporary suspension, permanent suspension, or termination of the contract.
      3. If a member does not log in for more than one year, the Company may restrict the use of the service to protect member information and for operational efficiency.
      4. The conditions and details of restrictions within the scope of this Article are determined by the Company's restriction policy.
      5. In the event of restricting service use or terminating the contract pursuant to this Article, the Company shall notify the member in accordance with Article 7.
      6. A member may file an objection to the restriction of use through the procedure prescribed by the Company. If deemed valid by the Company, the Company will immediately resume the service.
      7. In cases of restriction of use, all benefits obtained through service use may be forfeited, and the Company will not provide separate compensation for this.
    `,
  },
  {
    title: 'Article 17 (Limitation of Liability)',
    desc: `1. The Company shall not be liable for providing or compensating for failure of service due to force majeure or similar unavoidable circumstances.
      2. The Company is not responsible for changes or disruptions in free services provided by the Company.
      3. The Company is not responsible for inaccuracies in content provided by third parties or members.
      4. The Company is not responsible for any agreements or transactions between members or between members and advertisers or third parties.
      5. If proven by law, the Company will compensate for damages incurred by members due to reasons other than those in the preceding points.
    `,
  },
  {
    title: 'Article 18 (Dispute Resolution)',
    desc: `1. The Company shall establish a damage compensation organization to reflect and address inquiries, legitimate opinions, and complaints raised by members and compensate for damages.
      2. In the event of an electronic commerce dispute between the Company and a member, the Company may comply with the mediation of a dispute resolution organization.
    `,
  },
  {
    title: 'Article 19 (Jurisdiction)',
    desc: `1. Lawsuits between the Company and members shall be governed by the laws of the Republic of Korea.
      2. Lawsuits regarding disputes between the Company and members shall be under the exclusive jurisdiction of the competent court where the member's address is located at the time of filing.
      3. If the address or domicile is unclear, jurisdiction is determined by the Civil Procedure Act.
      4. For members residing overseas, lawsuits regarding disputes between the Company and the member shall be under the jurisdiction of the Seoul Central District Court.
    `,
  },
  {
    title: 'Article 20 (Supplementary Provisions)',
    desc: `1. These Terms shall be effective from November 6, 2023.
      2. These Terms shall take precedence over other agreements, and the definitions in Article 2 of these Terms shall apply to all agreements.
      3. All agreements shall not apply to sites linked to by the Types site provided directly by the Company.
      4. Matters not specified in these Terms shall be governed by the relevant laws.
    `,
  },
]

export const serviceZh = [
  {
    title: '第1條 (目的)',
    desc: '本MyTypes服務使用條款（以下簡稱“條款”）的目的是為了規範Ute有限公司（以下簡稱“公司”）與會員之間關於MyTypes服務內提供的各種定制服務的權利、義務和責任',
  },
  {
    title: '第2條（定義）',
    desc: '1. “公司”指提供服務的實體。\
    \n2. “服務”指公司提供的所有服務，包括性格測驗、測驗結果、化學分析和公司提供的個人檔案。它涵蓋為促進使用信息和通訊設施進行商品和服務交易而設立的虛擬商業場所。該服務還包括所有內容、功能、商品、服務及相關信息。\
    \n3. “會員”指訪問並同意這些條款並加入公司提供的服務的個人。\
    \n4. “ID”指會員確定並由公司批准用於識別和使用服務的字符或字符與數字的組合。\
    \n5. “個人檔案”指會員創建的用於在服務內進行活動的個人檔案，包括來自KakaoTalk的個人檔案圖片。\
    \n6. “性格類型測驗”指服務為會員使用提供的有關性格類型的所有問題和回答。\
    \n7. “朋友註冊”指在MyTypes服務內使用KakaoTalk聯絡人註冊其他會員。\
    \n8. “協議”指在服務內公司與會員之間包括購買、銷售、供應、支付、生產、調解和獎品在內的合同、協議或承諾。\
    \n9. “幣”指在本服務內用於付費服務的虛擬貨幣。\
    \n10. “付費服務”指公司為收費提供的各種數字內容和服務。\
    \n11. “購買”指會員使用公司提供的支付方式將現金兌換成幣的行為。\
    ',
  },
  {
    title: '第3條（條款的公布與修改）',
    desc: '1. 公司可在服務的底部、更多菜單、個人檔案及其他菜單、彈出窗口、橫幅等處公布所有必須明確的條款和信息。\
  \n2. 公司可以在不違反相關法律的範圍內修改這些條款。\
  \n3. 若修改後的內容對會員不利，公司應自修訂生效日期前30天起至生效前一日，在Ute應用程序的公告部分公告。\
  \n4. 根據第2款公告修訂條款後，如果會員在30天內未明確表示拒絕，則視為會員同意修訂條款。\
  \n5. 如果會員不同意適用修訂條款，會員可以通過終止服務合約來表示拒絕。\
  \n6. 公司可為付費服務和個別服務設立單獨的條款和政策，如與這些條款有衝突，以本條款為準。\
  \n7. 會員不能僅同意或不同意這些條款的一部分。\
  \n8. 即使這些條款的一部分被認為是不可執行的，其餘部分仍然有效。\
  ',
  },
  {
    title: '第4條（服務使用協議等）',
    desc: '1. 希望成為會員的個人應按照公司提供的規定申請表格輸入會員信息，並同意每項條款後點擊註冊按鈕。\
    \n2. 會員申請被認為已完成，當申請人完成註冊過程時。\
    \n3. 但如果發生以下情況，公司可在未經事先通知的情況下拒絕會員資格或終止服務合約：\
     \n - 如果申請人因不遵守每項條款或由於條款而失去會員資格。\
     \n - 如果出於任何其他原因認為不適合註冊為會員。\
    \n4. 公司可通過合作機構進行實名驗證和身份驗證，以防止濫用和驗證身份。\
    \n5. 如果會員在使用服務期間一年內未登錄，公司可撤銷其會員資格。\
    ',
  },
  {
    title: '第5條（會員的義務）',
    desc: '1. 會員使用服務即表示同意遵守所有適用的法律、規範和規定。此外，會員同意遵守特定的額外規定（以下簡稱“行為指南”），這些規定規範服務的使用。行為指南可能不涵蓋所有內容，公司保留隨時修改它們以保護服務的完整性和性質（通知會員）並採取適當的紀律行動，包括退款和永久停權，無論是否將特定行為列為禁止的權利。除了這些行為指南外，請參考服務內公布的會員規章和運營政策，以獲得有關模範服務使用行為和紀律措施的詳細指導。以下是可能導致制裁的行為示例，但此列表不是詳盡無遺的：\
    \n - 在申請或修改時提供虛假信息、遺漏、欺騙或身份盜用\
    \n - 損害公司或第三方的聲譽或擾亂業務運營的行為\
    \n - 侵犯公司的所有財產\
    \n - 在公司服務之外進行未授權的活動\
    \n - 冒充公司員工或服務管理員\
    \n - 未授權使用、更改、刪除或披露服務內的帖子和數據\
    \n - 收集、儲存、披露或使用他人或自己的個人信息，並將此類信息披露或轉讓給第三方\
    \n - 創建並使用多個賬戶\
    \n - 未授權的商業活動\
    \n - 違反 MyTypes 隱私政策或會員同意的任何其他條款的行為\
    \n - 在提供服務時被認為不適當或違反現行法律的行為\
    \n2. 如果用戶從事本條第2款所述禁止行動，公司可根據本條款第18條限制服務使用。\
    \n3. 會員必須及時更正自會員申請時起的信息不一致情況。\
    \n4. 如果存在技術或業務問題，相關於公司的服務設施，可能會保留批准。\
    \n5. 除非公司根據相關法律和各項協議負有責任，否則每位會員均負責管理其個人信息以防止濫用。\
    \n6. 如果會員發現其 ID 和密碼被盜或被第三方使用，必須立即通知公司並遵循公司的指示。\
    \n7. 在第4款所述情況下，如果會員未通知公司此類事實或即使在通知後也未遵循公司的指示，公司將不承擔因此造成的任何不利後果。\
    \n8. 如果由於會員的 ID 存在個人信息洩露、反社會行為或被誤認為公司或公司運營者的風險，公司可能限制該 ID 的使用。\
    ',
  },
  {
    title: '第6條（會員資訊的更改）',
    desc: '1. 會員可隨時透過服務內的“個人檔案”查看和修改其個人資訊。然而，出於服務管理的需要，終端識別號碼（設備ID或IMEI）、電話號碼及ID（電子郵件地址）不能修改。\
    \n2. 由於服務設施相關的技術或業務問題，公司不負責個人檔案的即時更改。\
    ',
  },
  {
    title: '第7條（對會員的通知）',
    desc: '1. 當公司通知特定會員時，可使用會員的個人資訊和內部服務工具。\
    \n2. 對所有會員的通知，公司可能在公告欄中發布，而不使用第1款描述的方法。\
    \n3. 如果會員在30天內未表達意向，則視為會員已同意通知內容。\
    ',
  },
  {
    title: '第8條（服務與協議的提供、修改、暫停及撤銷）',
    desc: '1. 公司提供所有內部開發或與其他公司合作提供的服務。\
    \n2. 會員可通過回覆、簽名或點擊按鈕等方式表達同意，在使用服務提供的功能購買商品或服務或參與活動時締結協議。\
    \n3. 使用服務或締結協議的會員被視為已同意使用服務或締結協議前所有指定內容。\
    \n4. 通過服務購買商品或服務時，會員可在購買時使用服務中指定的支付方式支付價格。\
    \n5. 除非另有約定，公司最多可在14天內提供商品或服務。\
    \n6. 公司可根據運營或技術需求變更所提供的服務。\
    \n7. 在檢查、故障、更換、修改或缺貨等不可避免的情況下，公司可暫時或永久暫停服務和協議並替換協議或經會員同意終止協議。如果終止了會員已支付的協議，公司將在終止日期起5個工作日內退款。\
    \n8. 服務變更和暫停的通知將按照第6條指定的方法進行。然而，如果服務因公司無法控制的情況暫停且無法通知，則不作通知。\
    ',
  },
  {
    title: '第9條（公司的義務）',
    desc: '1. 公司不得從事違反法律和這些條款或違背公序良俗的行為。\
    \n2. 公司應努力提供穩定、持續和便利的服務。\
    ',
  },
  {
    title: '第10條（版權所有權）',
    desc: '1. 由公司創建的帖子的權利屬於公司。因此，未經公司事先同意，會員不得複製、傳送、發布、分發或為商業目的向第三方提供使用服務獲得的資訊。\
    \n2. 由會員創建的帖子的權利屬於會員。然而，為了服務的運營、擴展和促銷，公司可在合理且必要的範圍內，無需另行許可，修改並使用會員的作品或免費提供給關聯公司。在此情況下，不提供個人資訊。\
    \n3. 如果公司以第2款未述方式使用會員的帖子，必須使用會員的個人資訊和內部服務工具獲得會員的同意。\
    ',
  },
  {
    title: '第11條（服務的管理）',
    desc: '1. 如果會員從事違反相關法律和各項協議的活動，公司可自行刪除、暫停或修改相關服務或帖子，並限制、暫停或撤銷會員的資格和權利。\
    \n2. 如果另一名會員或第三方因會員帖子造成的法律利益侵害向會員或公司採取法律行動或要求刪除相關帖子，公司可暫時限制訪問相關帖子。\
    ',
  },
  {
    title: '第12條（廣告的發布和傳播）',
    desc: '1. 為會員提供服務的一部分投資基礎來自於廣告收入。公司可能在服務中使用會員的帖子或其內容及其他服務來發布廣告。\
    \n2. 如果會員同意接收廣告資訊，公司可透過電子媒體如電子郵件、推送通知、一對一對話和短信傳送廣告資訊。\
    ',
  },
  {
    title: '第13條（付費服務內容的說明）',
    desc: '1. 公司應在使用付費服務的初始屏幕或購買硬幣的屏幕上清楚顯示以下項目，以便用戶容易理解：\
    \n - 付費服務的名稱或標題\
    \n - 付費服務的內容、使用方法、費用及其他條件\
    \n - 使用公司付費服務所需的最低技術規格基於推薦規格資訊。\
    \n - 公司提供關於付費服務的交換、退貨、保證和退款的條件和程序信息。\
    \n - 使用付費服務的硬幣購買可以通過App Store和Google Play Store的退款請求進行撤銷。\
    ',
  },
  {
    title: '第14條（硬幣的使用與過期）',
    desc: '1. 硬幣是可以在服務中使用的貨幣單位。會員可以使用其擁有的硬幣在服務內購買付費服務。\
    \n2. 如果會員刪除自己的帳戶或由於會員的過失導致服務帳戶被刪除，該帳戶上購買的硬幣將自動過期。\
    \n3. 如果由於會員的過失導致服務帳戶受到限制，則在限制期間內不能使用硬幣。\
    \n4. 如果在獲取硬幣時出現問題，您可以在問題發生後30天內向公司請求更正，公司可能會在請求之日起30天內進行調整。\
    \n5. 使用硬幣的順序遵循公司設定的政策。\
    ',
  },
  {
    title: '第15條（服務協議的終止）',
    desc: '1. 會員可隨時通過“撤銷”要求終止服務協議，公司必須依照相關法律迅速處理。\
    \n2. 會員終止服務協議後，所有個人資訊將依照相關法律和MyTypes隱私政策進行處理。\
    \n3. 如果會員在終止服務協議後重新註冊，終止帳戶的所有權利，包括發帖權限，不得轉移。\
    ',
  },
  {
    title: '第16條（使用限制等）',
    desc: '1. 如果會員違反這些條款下的義務或干擾服務的正常運作，公司可以立即採取措施，如警告、警示、暫時暫停、永久暫停或終止合約，會員應承擔法律責任。\
    \n2. 如果會員違反相關法律，如違反居民登記法進行身份盜用和支付欺詐，違反版權法非法提供和操作干擾非法程序，違反信息通信網利用和信息保護法進行非法通信和黑客行為，散布惡意程序，未經授權訪問及類似欺詐行為，公司可立即採取措施，如警告、警示、暫時暫停、永久暫停或終止合約，會員應承擔法律責任。\
    \n3. 如果會員超過一年未登錄，公司可能為保護會員信息和運營效率限制使用服務。\
    \n4. 限制範圍內的條件和細節由公司的限制政策確定。\
    \n5. 根據本條進行服務使用限制或終止合約的情況下，公司應按照第7條的規定通知會員。\
    \n6. 會員可通過公司規定的程序對使用限制等提出異議。如果公司認為異議有效，將立即恢復服務。\
    \n7. 根據本條進行使用限制的情況下，通過服務使用獲得的所有利益也將被暫停或沒收，公司不提供單獨的賠償。\
    ',
  },
  {
    title: '第17條（責任限制）',
    desc: '1. 在以下情況下，公司不承擔任何責任或賠償，並且可以在不另行通知的情況下限制、暫停或撤銷資格，如果是會員的過失：\
    \n - 由於不可抗力或等同不可避免的情況無法提供服務\
    \n - 公司提供的免費服務的變更或中斷\
    \n - 當公司證明無意圖或疏忽\
    \n - 在公司銷售的產品價格錯誤低於建議零售價的90%的情況下\
    \n - 關於會員發布內容的資訊、數據、可靠性、準確性等\
    \n - 關於會員或會員與廣告商或第三方之間約定的交易\
    \n - 如果會員在使用服務時未遵守公司的條款和義務\
    \n2. 除第1款所述情況外，如果會員因購買商品或服務而遭受損害，只要存在法律上證明的因果關係，公司應對損害負責。\
    ',
  },
  {
    title: '第18條（爭議解決）',
    desc: '1. 公司應設立並運營損害賠償組織，以反映並解決會員提出的查詢、合法意見和投訴，並賠償損害。\
    \n2. 在公司與會員之間發生電子商務爭議的情況下，公司可遵守由公平交易委員會或市長或省長指定的爭議解決機構的調解。\
    ',
  },
  {
    title: '第19條（管轄權）',
    desc: '1. 公司與會員之間的訴訟應受韓國法律管轄，並在有管轄權的法院提起訴訟。\
    \n2. 關於公司與會員之間的爭議訴訟應受提訴時會員地址所在地區法院的專屬管轄，如果地址不清楚，則根據民事訴訟法進行確定。\
    \n3. 如果會員的地址或住所在海外，不論前款規定如何，公司與會員之間的爭議訴訟應受首爾中央地方法院的管轄。\
    ',
  },
  {
    title: '第20條（附則）',
    desc: '1. 這些條款自2023年11月6日起生效。\
    \n2. 這些條款優先於其他協議，第2條的定義適用於所有協議。\
    \n3. 所有協議不適用於公司直接提供的MyTypes網站所鏈接的網站。\
    \n4. 未在這些條款中指定的事項應受相關法律管轄。\
    ',
  },
]

export const serviceJa = [
  {
    title: '第1条（目的）',
    desc: 'タイプズサービス利用規約（以下、「本規約」といいます）は、Ute株式会社（以下、「会社」といいます）と会員との間の権利・義務・責任を、タイプズサービス内で提供される様々なカスタマイズサービスに関して規定することを目的とします。',
  },
  {
    title: '第2条（定義）',
    desc: '1.「会社」とは、サービスを提供する主体を指します。\
    \n2.「サービス」とは、性格診断、診断結果、相性分析、プロフィールを含む、会社が提供するすべてのサービスを指します。これは、情報通信設備を利用して商品やサービスの取引を促進するために設置された仮想営業所も含まれます。サービスにはすべてのコンテンツ、機能、商品、サービス、および関連する情報も含まれます。\
    \n3.「会員」とは、本規約に同意し、会社が提供するサービスに加入した個人を指します。\
    \n4.「ID」とは、会員が決定し、会社が承認した識別のための文字の組み合わせまたは文字と数字の組み合わせを指します。\
    \n5.「プロフィール」とは、会員がサービス内での活動に参加するために作成したプロフィールを指し、カカオトークのプロフィール画像を含みます。\
    \n6.「性格タイプクイズ」とは、会員が利用するためにサービスが提供する性格タイプに関するすべての質問と回答を指します。\
    \n7.「友達登録」とは、カカオトークの連絡先を使用してタイプズサービス内で他の会員を登録することを指します。\
    \n8.「契約」とは、サービス内で会社と会員との間に結ばれる契約、合意、または約束を指し、購入、販売、供給、支払い、製作、媒介、賞品などが含まれます。\
    \n9.「コイン」とは、本サービス内の有料サービスに使用される仮想通貨を指します。\
    \n10.「有料サービス」とは、会社が料金を徴収することで提供するさまざまなデジタルコンテンツとサービスを指します。\
    \n11.「購入」とは、会員が現金を会社が提供する支払手段を利用してコインに換える行為を指します。',
  },
  {
    title: '第3条（規約の告知と改訂）',
    desc: '1. 会社は、すべての規約と法律に基づき指定すべき情報をサービスの下部、もっと見るメニュー、プロフィール、その他のメニュー、ポップアップ、バナーなどに掲示することができます。\
    \n2. 会社は関連法を遵守する範囲内で本規約を改訂することができます。\
    \n3. 改訂された内容が会員に不利である場合、会社はその適用日から30日前までにUteアプリサービス内の通知欄で告知します。\
    \n4. 会員が改訂された規約に明確に拒否を表明しない場合、30日間の間に同意したものと見なされます。\
    \n5. 会員が改訂された規約の適用に同意しない場合、サービス契約の解約によって拒否を表明することができます。\
    \n6. 会社は有料サービスおよび個別サービスに対して別途の規約およびポリシーを設けることができ、これらの規約と矛盾する場合は本規約が優先されます。\
    \n7. 会員は本規約の一部にのみ同意または不同意することはできません。\
    \n8. 本規約の一部が執行不能と見なされた場合でも、残りの部分は有効です。',
  },
  {
    title: '第4条（サービス利用契約の締結等）',
    desc: '1. 会員になろうとする個人は、会社が提供する所定の申込書に従って会員情報を入力し、すべての規約に同意して登録ボタンをクリックすることで会員申請を行うことができます。\
    \n2. 会員申込みの完了は、申請者が登録を完了した時点で成立したものと見なされます。\
    \n3. 会社は、以下の場合に通知なく会員資格を拒否またはサービス契約を解除することがあります。\
    \n - 各規約や条項に従わなかったため会員資格を失った場合。\
    \n - その他の理由により、会員登録が不適切であると判断される場合。\
    \n4. 会社は、不正使用の防止と本人確認のため、必要に応じて提携機関を通じて実名確認および本人認証を要求することができます。\
    \n5. 会員がサービスを利用して1年間ログインしなかった場合、会社は会員資格を取り消すことがあります。',
  },
  {
    title: '第5条（会員の義務）',
    desc: `1. 会員がサービスを使用することで、すべての適用法、規範、規則を遵守することに同意したものと見なされます。さらに、サービス利用を統制する特定の追加規則（以下「行動指針」といいます）に従うことに同意します。行動指針はすべての内容を網羅するものではなく、会社はサービスの誠実性と本質を保護するために、会員に通知することでいつでも行動指針を変更および適用でき、返金や永久停止を含む適切な懲戒措置を講じることができます。具体的な行為が禁止されているかどうかにかかわらず。
      2. これらの行動指針に加え、サービス内に掲示される会員規約および運営方針を参照してください。模範的なサービス利用行動と懲戒措置に関する詳細なガイダンスとして、以下は制裁の対象となる行動の一例ですが、このリストは網羅的ではありません。
        - 申請または変更時に虚偽の情報を提供、詐欺、身元詐称
        - 会社や第三者の名誉を毀損したり、業務を妨害する行為
        - 会社のすべての財産を侵害する行為
        - 会社のサービス外での不正行為
        - 会社の従業員やサービス管理者を装う行為
        - サービス内の投稿やデータの無断使用、変更、削除、公開
        - 他人または自身の個人情報を収集、保存、公開または使用し、その情報を第三者に公開または転送する行為
        – 複数アカウントの作成及び使用
        – 無許可の商業活動
        - タイプズプライバシーポリシーや会員が同意した他の条項への違反
        - サービスの提供において不適切と判断される、または現行の法律に違反する行為
      3. 本条第2項に基づく禁止行為を会員が行った場合、会社は第18条に従い、サービス利用を制限する措置を講じることがあります。
      4. 会員は、申込み時から生じた情報の不一致を速やかに訂正しなければなりません。
      5. 会社のサービス施設に関連する技術的または商業的課題がある場合、承認が保留されることがあります。
      6. 会社が関連法や各契約に基づいて責任を負う場合を除き、会員自身の情報を不正使用されないように管理する責任は各自にあります。
      7. 会員が自身のIDおよびパスワードが第三者に盗まれたか第三者に使用されていることを認識した場合には、直ちに会社に通知し、会社の指示に従わなければなりません。
      8. 第4項に基づく場合、会員が会社にその事実を通知しないか、通知した後に会社の指示に従わない場合、会員が被った不利益について会社は責任を負わないものとします。
      9. 会員のIDが個人情報漏洩の恐れがある場合、社会的に不適切な行動を意味する場合、または会社やその運営者と誤解されるような場合、会社はそのIDの使用を制限することができます。
    `,
  },
  {
    title: '第6条（会員情報の変更）',
    desc: `1. 会員は、サービス内の「プロフィール」を通じて、いつでも自分の個人情報を閲覧および変更できます。ただし、サービス管理に必要な端末識別番号（デバイスIDまたはIMEI）、電話番号、ID（メールアドレス）は変更できません。
      2. 会社は、サービス施設に関連する技術的または商業的な問題により、プロフィールを即座に変更できない場合があります。
    `,
  },
  {
    title: '第7条（会員への通知）',
    desc: `1. 特定の会員に通知を行う際、会社は会員の個人情報および社内のサービスツールを使用することができます。
      2. 全会員への通知については、前項の方法ではなく、通知欄に掲示する場合があります。
      3. 会員が30日間に意志を表明しない場合、通知内容に同意したものとみなします。
    `,
  },
  {
    title: '第8条（サービス及び契約の提供・変更・中断・解除）',
    desc: `1. 会社は、内部開発または他の会社との協力により開発されたすべてのサービスを会員に提供します。
      2. 会員は、サービス内で提供される機能を使用して、商品やサービスの購入やイベントへの参加のために同意を示すことで契約を締結できます。
      3. サービスを利用または契約を締結することにより、会員はサービスを使用する前または契約を締結する前に指定されたすべての内容に同意したものとみなされます。
      4. サービスを通じて商品やサービスを購入する際、会員は購入時にサービスに指定された方法を使用して料金を支払うことができます。
      5. 会社は、特別な合意がない限り、最大14日以内に商品やサービスを提供することができます。
      6. 会社は、運営上または技術的な必要性に基づいて提供されるサービスを変更することができます。
      7. 点検、故障、交換、修正、在庫切れなどの避けられない状況において、会社は一時的または永続的にサービスおよび契約を中断し、会員の同意の下で契約を置き換えるか、契約を終了することができます。支払いが行われた契約が終了した場合、会社は終了日から5営業日以内に支払いを返金します。
      8. サービスの変更や中断の通知は、第6条に定められた方法に従って行われます。ただし、会社の制御を超えた状況によりサービスが中断され、通知が不可能な場合、通知は行われません。
    `,
  },
  {
    title: '第9条（会社の義務）',
    desc: `1. 会社は、法律および本規約によって禁止される行為や公序良俗に反する行為を行わないものとします。
      2. 会社は、安定した、継続的かつ便利なサービスを提供するよう努めます。
    `,
  },
  {
    title: '第10条（著作権の所有権）',
    desc: `1. 会社が作成した投稿の権利は、会社に帰属します。会員は、サービスを使用して取得した情報を、会社の事前の同意なしに商業目的のために複製、送信、出版、配布、または第三者に提供することはできません。
      2. 会員が作成した投稿の権利は、会員に帰属します。ただし、サービスの運営、拡大、促進のためには、会社は合理的かつ必要な範囲内で別途の許可なしに会員の作品を修正して使用することができ、提携先に無料で提供することができます。この場合、個人情報は提供されません。
      3. 会社が第2項に記載された方法以外で会員の投稿を使用する場合、会社は会員の個人情報および社内サービスツールを使用して会員の同意を得なければなりません。
    `,
  },
  {
    title: '第11条（サービスの管理）',
    desc: `1. 会員が関連法や各契約に違反する活動に従事した場合、会社は自己の裁量で関連するサービスまたは投稿を削除、中断、または修正し、会員の資格と権利を制限、停止、または取り消すことができます。
      2. 他の会員または第三者が会員または会社に対して法的措置を取るか、会員の投稿により法的利益が損なわれたとして関連する投稿の削除を求めた場合、会社は一時的に関連する投稿へのアクセスを制限することができます。
    `,
  },
  {
    title: '第12条（広告の掲載と配信）',
    desc: `1. 会員にサービスを提供するための投資基盤の一部は、広告収入に由来します。会社は、会員の投稿やそのコンテンツを使用して、サービス上に広告を掲載することができます。
      2. 会員が広告情報の受信に同意した場合、会社は電子メディア（メール、プッシュ通知、1:1対話、テキストメッセージなど）を通じて広告情報を配信することができます。
    `,
  },
  {
    title: '第13条（有料サービスのコンテンツの表示）',
    desc: `1. 会社は、利用者が簡単に理解できるように、有料サービスの利用開始画面またはコイン購入画面に以下の項目を明示します。
      2. 有料サービスの名称またはタイトル
      3. 有料サービスの内容、使用方法、料金、その他条件
      4. 会社の有料サービスの使用に必要な最低技術仕様は、推奨仕様情報に基づきます。
      5. 会社は、有料サービスの交換、返品、保証、返金の条件と手続きに関する情報を提供します。
      6. 有料サービスを利用するためのコイン購入の取り消しは、App StoreおよびGoogle Play Storeを通じた返金リクエストで可能です。
    `,
  },
  {
    title: '第14条（コインの使用と期限）',
    desc: `1. コインは、サービス内で使用できる貨幣単位です。会員はサービス内で有料サービスを購入するために所持しているコインを使用することができます。
      2. 会員が自身のアカウントを削除した場合、または会員の過失によりサービスアカウントが削除された場合、そのアカウントで購入したコインは自動的に失効します。
      3. 会員の過失によりサービスアカウントの制限が行われた場合、制限期間中はコインを使用できません。
      4. コインの取得に問題がある場合、発生から30日以内に会社に修正を依頼することができ、会社はその依頼日から30日以内に調整することができます。
      5. コインの使用順位は会社のポリシーに従います。
    `,
  },
  {
    title: '第15条（サービス契約の終了）',
    desc: `1. 会員は「退会」を通じていつでもサービス契約の終了を要求することができ、会社は関連法に従い直ちに処理しなければなりません。
      2. 会員によるサービス契約の終了に際して、すべての個人情報は関連法およびタイプズプライバシーポリシーに従って処理されます。
      3. サービス契約を終了した会員が再登録した場合、その終了したアカウントの投稿権限などすべての権利は移行されません。
    `,
  },
  {
    title: '第16条（利用の制限等）',
    desc: `1. 会員が本規約に基づく義務に違反、またはサービスの通常の運営を妨げた場合、会社は警告、警戒、一時停止、永久停止、契約の解除など、直ちに措置を講ずることができ、会員は法的な責任を負います。
      2. 身元詐称、支払い詐欺、違法プログラム、違法通信、ハッキングなど関連法律に違反する場合、会社は警告、警戒、一時停止、永久停止、契約の解除など、直ちに措置を講ずることができます。
      3. 会員が1年以上ログインしない場合、会社は会員情報の保護および運営効率のためにサービスの利用を制限することがあります。
      4. 本条の範囲内での制限の条件および詳細は、会社の制限ポリシーによって決定されます。
      5. 本条に基づくサービス利用の制限または契約の解除を行う場合、会社は第7条に基づいて会員に通知します。
      6. 会員は会社の定める手順を通じて利用制限に対して異議を申し立てることができます。 会社が有効と判断した場合、直ちにサービスを再開します。
      7. 利用が制限された場合、サービス利用を通じて得られたすべての利益は放棄され、会社はこれに対して別途補償を行いません。
    `,
  },
  {
    title: '第17条（責任制限）',
    desc: `1. 会社は、不可抗力またはそれに類する避けられない事情により、サービス提供の失敗に対して賠償責任を負いません。
      2. 会社は、会社が提供する無料サービスの変更や中断について責任を負いません。
      3. 会社は、第三者または会員が提供するコンテンツの不正確さについて責任を負いません。
      4. 会社は、会員間または会員と広告主または第三者間の合意または取引について責任を負いません。
      5. 法律で立証された場合、会社は前項以外の理由で会員が被った損害に対して補償を行います。
    `,
  },
  {
    title: '第18条（紛争解決）',
    desc: `1. 会社は、会員によって提起された正当な意見や苦情を反映し、補償するために損害補償組織を設立します。
      2. 会社と会員間の電子商取引に関する紛争が発生した場合、会社は紛争解決機関による調停を受け入れることがあります。
    `,
  },
  {
    title: '第19条（管轄）',
    desc: `1. 会社と会員間の訴訟は、大韓民国の法律に準拠します。
      2. 会社と会員間の紛争に関する訴訟は、提起時に会員の住所がある管轄裁判所の専属管轄権に属します。
      3. 住所または居所が不明な場合、管轄権は民事訴訟法によって決定されます。
      4. 海外に居住する会員に対する会社と会員間の紛争に関する訴訟は、ソウル中央地方裁判所の管轄に属します。
    `,
  },
  {
    title: '第20条（補足規定）',
    desc: `1. 本規約は2023年11月6日から有効です。
      2. 本規約は他の契約に優先し、すべての契約において第2条の定義が適用されます。
      3. 会社が直接提供するタイプズサイトによってリンクされるサイトには、すべての契約が適用されません。
      4. 本規約に明示されていない事項については関連法に準拠します。
    `,
  },
]

export const personalDataKo = [
  {
    title: '1. 수집하는 개인정보의 항목',
    subtitle:
      '회원은 본인의 선택으로 회원가입을 한 뒤 서비스를 이용할 수 있습니다. 이 경우, 회사는 회원가입 시점부터 아래와 같은 개인정보 중 일부를 수집합니다. 단, 회원이 각 항목에 해당되지 않을 경우, 해당 항목의 개인정보는 절대 수집하지 않습니다.',
    desc: '1) 카카오톡 계정으로 회원 가입시(필수)\
        \n- 닉네임, 프로필 이미지\
        \n2) 카카오톡 계정으로 회원 가입시(선택적)\
        \n- 성별, 출생년도, 전화번호\
        \n3) 성격 유형 퀴즈 응답시\
        \n- 퀴즈 응답 대상 회원, 퀴즈 응답 결과 일체\
        \n4) 추가 퀴즈 등록시\
        \n- 추가 퀴즈 질문, 추가 퀴즈 응답\
        \n5) 카카오톡 친구 등록 연동 시\
        \n- 내가 팔로우하는 친구\
        \n6) 제휴/협력 및 게시 요청 시\
        \n- 단체명, 이름, 직책, 이메일, 연락처\
        \n7) 서비스 이용과정에서 자동 수집되는 정보\
        \n- IP Address, 쿠키, 방문 일시, 서비스 이용기록, 불량 이용 기록, 기기정보, ADID, IDFA\
        \n※ 각 항목 또는 추가적으로 수집이 필요한 항목의 개인정보는 문의하기를 통한 회원 지원 과정 및 별도의 알림창을 통해서 서비스 이용 중 수집될 수 있습니다.\
        \n※ 회사는 인종, 사상, 의료정보 등 회원의 민감정보를 절대로 수집하지 않습니다.\
        \n※ 회사와 제휴한 외부 기업이나 단체로부터 개인정보를 제공받을 수 있으며, 이러한 경우에는 제휴사에서 이용자에게 개인정보 제공 동의를 받은 후 수집합니다.',
  },
  {
    title: '2. 개인정보의 수집 및 이용목적',
    subtitle: '회사는 쾌적한 서비스를 제공하기 위해, 아래의 목적에 한해 개인정보를 이용합니다.',
    desc: '1) 회원 식별, 가입의사 및 탈퇴의사 확인, 부정이용 및 중복가입 방지 등 회원관리\
        \n2) ‘퀴즈 결과 순위’, ‘케미가 맞는 친구 추천’ 등 맞춤 추천 서비스 개발·제공·개선\
        \n3) 회원 문의/제안/제휴/협력/게시 요청 처리, 공지사항 전달\
        \n4) 신규 서비스 개발 및 마케팅, 광고에 활용\
        \n5) 회원들이 알 수도 있는 다른 회원들을 찾도록 돕는데 활용\
        \n6) 기타 회사와 회원 간 체결된 약정 이행',
  },
  {
    title: '3. 개인정보 수집방법',
    subtitle:
      '회사는 어플리케이션, 웹 서비스, 이벤트 참여, 제휴사로부터의 전달, 거래과정 등을 통해 개인정보를 수집합니다.',
    desc: '',
  },
  {
    title: '4. 개인정보의 보유 및 이용기간',
    subtitle:
      '이용자의 개인정보는 원칙적으로 개인정보의 수집 및 이용목적이 달성되면 지체 없이 파기합니다. 단, 다음의 정보에 대해서는 아래의 이유로 명시한 기간 동안 보존합니다.',
    desc: '1) 회사 내부 방침에 의한 정보보유 사유\
        \n보존 항목: 부정 이용 기록\
        \n- 보존 이유: 부정 이용 방지\
        \n- 보존 기간: 5년\
        \n보존 항목: 탈퇴 회원 개인정보\
        \n- 보존 이유: 재가입 악용 방지, 명예훼손 등 권리침해 분쟁 및 수사협조\
        \n- 보존 기간: 1년\
        \n※ 커뮤니티 게시물 유출, 아이디 공유 등 서비스 부정 사용 및 커뮤니티 이용규칙 위반 회원의 재가입 및 이용 제한을 위해 휴대폰 번호, 이메일을 비식별화하여 최대 5년간 보관합니다.\
        \n2) 관련 법령에 의한 정보보유 사유\
        \n보존 항목: 대금결제 및 재화 등의 공급에 관한 기록\
        \n- 근거 법령: 전자상거래 등에서의 소비자보호에 관한 법률\
        \n- 보존 기간: 5년\
        \n보존 항목: 계약 또는 청약철회 등에 관한 기록\
        \n- 근거 법령: 전자상거래 등에서의 소비자보호에 관한 법률\
        \n- 보존 기간: 5년\
        \n보존 항목: 소비자의 불만 또는 분쟁처리에 관한 기록\
        \n- 근거 법령: 전자상거래 등에서의 소비자보호에 관한 법률\
        \n- 보존 기간: 3년\
        \n보존 항목: 대금결제 및 재화 등의 공급에 관한 기록\
        \n- 근거 법령: 전자상거래 등에서의 소비자보호에 관한 법률\
        \n- 보존 기간: 5년\
        \n보존 항목: 본인확인에 관한 기록\
        \n- 근거 법령: 정보통신망 이용촉진 및 정보보호 등에 관한 법률\
        \n- 보존 기간: 6개월\
        \n보존 항목: 방문에 관한 기록\
        \n- 근거 법령: 통신비밀보호법\
        \n- 보존 기간: 3개월',
  },
  {
    title: '5. 개인정보의 파기 절차 및 방법',
    subtitle:
      '회사는 개인정보 수집 및 이용목적이 달성된 후에는 지체없이 해당 정보를 파기합니다. 종이에 출력된 개인 정보는 분쇄기로 분쇄하거나 소각을 통하여 파기하고, 전자적 파일 형태로 저장된 개인정보는 기록을 재생할 수 없는 기술적 방법을 사용하여 삭제합니다. (비식별화된 정보는 일방향 암호화된 정보이므로, 복호화가 불가능하며, 누구라도 이 정보로 개인을 식별하거나 유추할 수 없습니다.)',
    desc: '',
  },
  {
    title: '6. 개인정보의 제공 및 공유',
    subtitle:
      '회사는 회원이 서비스 이용과정 등에서 따로 동의하는 경우나 법령에 규정된 경우를 제외하고는 사용자 개인정보를 위에서 언급한 목적 범위를 초과하여 제공하거나 공유하지 않습니다.',
    desc: '',
  },
  {
    title: '7. 이용자 및 법정 대리인의 권리, 의무 및 행사 방법',
    subtitle:
      '사용자는 언제든지 사용자 개인정보를 조회하거나 수정할 수 있으며 수집∙이용에 대한 동의 철회 또는 가입 해지를 요청할 수도 있습니다. 보다 구체적으로는 서비스 내 설정 기능을 통한 변경, 가입 해지(동의 철회)를 위해서는 서비스 내 "계정탈퇴"를 클릭하면 되며, 운영자에게 이메일이나 별도 게시판으로 문의할 경우도 지체 없이 조치하겠습니다.',
    desc: '',
  },
  {
    title: '8. 개인정보 자동수집 장치의 설치, 운영 및 그 거부에 관한 사항',
    subtitle:
      '회사는 이용자의 정보를 자동으로 저장하고 찾아내는 ‘쿠키(cookie)’ 등을 운용합니다. 쿠키란 웹사이트를 운영하는데 이용되는 서버가 귀하의 브라우저에 보내는 아주 작은 텍스트 파일로서 귀하의 컴퓨터 하드디스크에 저장됩니다.',
    desc: '1) 쿠키 등의 사용 목적\
        \n개인화되고 맞춤화된 서비스를 제공하기 위해서 이용자의 정보를 저장하고 수시로 불러오는 쿠키를 사용합니다. 이용자가 웹사이트에 방문할 경우 웹 사이트 서버는 이용자의 디바이스에 저장되어 있는 쿠키의 내용을 읽어 이용자의 환경설정을 유지하고 맞춤화된 서비스를 제공하게 됩니다. 쿠키는 이용자가 웹 사이트를 방문할 때, 웹 사이트 사용을 설정한대로 접속하고 편리하게 사용할 수 있도록 돕습니다. 또한, 이용자의 웹사이트 방문 기록, 이용 형태를 통해서 최적화된 광고 등 맞춤형 정보를 제공하기 위해 활용됩니다.\
        \n2) 쿠키 설정 거부 방법\
        \n쿠키 설정을 거부하는 방법으로는 회원님이 사용하시는 앱이나 웹 브라우저의 옵션을 선택함으로써 모든 쿠키를 허용하거나 쿠키를 저장할 때마다 확인을 거치거나, 모든 쿠키의 저장을 거부할 수 있습니다.',
  },
  {
    title: '9. 개인정보보호를 위한 기술적 관리적 조치',
    subtitle:
      '회사는 이용자의 개인정보를 취급함에 있어 개인정보가 분실, 도난, 누출, 변조 또는 훼손되지 않도록 안정성 확보를 위하여 다음과 같은 기술적, 관리적 대책을 강구하고 있습니다.',
    desc: '1) 이용자의 개인정보는 비밀번호에 의해 보호되며, 중요한 데이터는 파일 및 전송 데이터를 암호화하거나 파일 잠금 기능을 사용하는 등의 별도 보안기능을 통해 보호하고 있습니다.\
        \n2) 회사는 해킹이나 컴퓨터 바이러스 등에 의해 이용자의 개인정보가 유출되거나 훼손되는 것을 막기 위해 외부로부터 접근이 통제된 구역에 시스템을 설치하고, 침입 차단장치 이용 및 침입 탐지시스템을 설치하여 24시간 감시하고 있습니다.\
        \n3) 회사는 개인정보를 처리할 수 있도록 체계적으로 구성한 데이터베이스시스템에 대한 접근권한의 부여, 변경, 말소 등에 관한 기준을 수립하고 비밀번호의 생성 방법, 변경 주기 등을 규정 운영하며 기타 개인정보에 대한 접근통제를 위해 필요한 조치를 다하고 있습니다.\
        \n4) 개인정보관련 취급 직원은 담당자에 한정시켜 최소화하고 새로운 보안기술의 습득 및 개인정보 보호 의무에 관해 정기적인 교육을 실시하며 별도의 비밀번호를 부여하여 접근 권한을 관리하는 등 관리적 대책을 시행하고 있습니다.\
        \n5) 이용자가 사용하는 ID와 비밀번호는 원칙적으로 이용자만이 사용하도록 되어 있습니다. 회사는 이용자의 개인적인 부주의로 ID, 비밀번호, 이메일 등 개인정보가 유출되어 발생한 문제와 기본적인 인터넷의 위험성 때문에 일어나는 일들에 대해 책임을 지지 않습니다.',
  },
  {
    title: '10. 개인정보관리책임자 및 문의처',
    subtitle:
      '회사의 서비스를 이용하며 발생하는 모든 개인정보보호 관련 민원을 개인정보관리책임자 혹은 담장부서로 제보하실 수 있습니다.',
    desc: '개인정보관리책임자\
        \n- 이름: 박준혜\
        \n- 직위: 대표\
        \n- 연락처: contact@hellowoot.co.kr',
  },
  {
    title: '11. 개인정보처리방침의 개정과 고지',
    subtitle:
      '우트는 법률이나 서비스의 변경사항을 반영하기 위한 목적 등으로 개인정보처리방침을 수정할 수 있습니다. 개인정보처리방침이 변경되는 경우 우트는 변경 사항을 게시하며, 변경된 개인정보처리방침은 게시한 날로부터 7일 후부터 효력이 발생합니다.',
    desc: '공고일자: 2022년 7월 18일\
        \n시행일자: 2022년 7월 25일',
  },
]

export const personalDataEn = [
  {
    title: '1. Types of Personal Information Collected',
    subtitle:
      'Members can choose to sign up for membership and use the service. In this case, the Company collects some of the following personal information from the time of membership registration. However, if a member does not fall under each item, the personal information for that item will never be collected.',
    desc: '1) When signing up with an apple or google account (required)\
        \n- Account username\
        \n2) When signing up with an apple or google account (optional)\
        \n- Email address\
        \n3) When responding to personality type quizzes\
        \n- Members targeted for quiz responses, all quiz response results\
        \n4) When registering additional quizzes\
        \n- Additional quiz questions, additional quiz responses\
        \n5) When linking KakaoTalk friends\
        \n- Friends I follow\
        \n6) When requesting affiliation/collaboration or posting\
        \n- Group name, name, position, email, contact number\
        \n7) Information automatically collected during service usage\
        \n- IP Address, cookies, visit date, service usage records, misconduct records, device information, ADID, IDFA\
        \n※ Personal information for each item or additional items that may need to be collected may be collected during the service through the member support process via inquiries or through separate notification windows.\
        \n※ The Company never collects sensitive information such as race, ideology, or medical information.\
        \n※ Personal information may be provided by external companies or organizations affiliated with the Company, and in such cases, it is collected after the affiliate obtains consent from the user.',
  },
  {
    title: '2. Purposes of Collection and Use of Personal Information',
    subtitle: 'To provide a pleasant service, the Company uses personal information only for the following purposes.',
    desc: '1) Member identification, confirmation of intent to join and withdraw, prevention of misuse and duplicate registrations, member management\
        \n2) Development, provision, and improvement of personalized recommendation services such as "Quiz Result Rankings" and "Recommended Friends with Chemistry"\
        \n3) Processing member inquiries/suggestions/affiliations/collaborations/posting requests, delivering announcements\
        \n4) Utilization in the development of new services and marketing, advertising\
        \n5) Assisting members in finding other members they may know\
        \n6) Fulfilling agreements between the Company and members',
  },
  {
    title: '3. Methods of Personal Information Collection',
    subtitle:
      'The Company collects personal information through applications, web services, event participation, information transferred from affiliated companies, and transaction processes.',
    desc: '',
  },
  {
    title: '4. Retention and Use Period of Personal Information',
    subtitle:
      'The personal information of users is promptly destroyed once the purpose of collecting and using personal information is achieved. However, the following information is retained for the specified period for the reasons stated below.',
    desc: '1) Information retention reasons based on internal company policy\
        \nRetention items: Misconduct records\
        \n- Reason for retention: Prevention of misconduct\
        \n- Retention period: 5 years\
        \nRetention items: Personal information of withdrawn members\
        \n- Reason for retention: Prevention of misuse of re-registration, cooperation in rights infringement disputes and investigations\
        \n- Retention period: 1 year\
        \n※ For users who violate service rules, such as leaking community posts or sharing IDs, phone numbers, and emails are anonymized and stored for up to 5 years to prevent re-registration and service restriction.\
        \n2) Information retention reasons based on relevant laws\
        \nRetention items: Records of payment and supply of goods, etc.\
        \n- Legal basis: Act on Consumer Protection in Electronic Commerce, etc.\
        \n- Retention period: 5 years\
        \nRetention items: Records of contracts or subscription withdrawals, etc.\
        \n- Legal basis: Act on Consumer Protection in Electronic Commerce, etc.\
        \n- Retention period: 5 years\
        \nRetention items: Records of consumer complaints or dispute resolution\
        \n- Legal basis: Act on Consumer Protection in Electronic Commerce, etc.\
        \n- Retention period: 3 years\
        \nRetention items: Records related to payment and supply of goods, etc.\
        \n- Legal basis: Act on Consumer Protection in Electronic Commerce, etc.\
        \n- Retention period: 5 years\
        \nRetention items: Records of identity verification\
        \n- Legal basis: Information and Communications Network Utilization and Information Protection Act\
        \n- Retention period: 6 months\
        \nRetention items: Records of visits\
        \n- Legal basis: Act on Protection of Communications Secrets\
        \n- Retention period: 3 months',
  },
  {
    title: '5. Procedure and Method for Destruction of Personal Information',
    subtitle:
      'The Company promptly destroys the relevant information once the purpose of collecting and using personal information has been achieved. Personal information printed on paper is shredded or incinerated using a shredder, while personal information stored in electronic file formats is deleted using technical methods that make it impossible to reproduce records. (De-identified information is one-way encrypted information, making it impossible to decrypt, and no one can identify or infer individuals from this information.)',
    desc: '',
  },
  {
    title: '6. Provision and Sharing of Personal Information',
    subtitle:
      'Except in cases where users separately agree during the service usage process or as stipulated by law, the Company does not provide or share user personal information beyond the scope mentioned above.',
    desc: '',
  },
  {
    title: '7. Rights, Obligations, and Methods of Exercising Rights of Users and Legal Representatives',
    subtitle:
      'Users can access or modify their personal information at any time, and may also request withdrawal of consent or termination of membership. Specifically, for changes or membership termination (withdrawal of consent), users can click on "Account Deletion" within the service, or if contacting the administrator via email or separate bulletin board, appropriate measures will be taken promptly.',
    desc: '',
  },
  {
    title:
      '8. Matters Concerning the Installation, Operation, and Rejection of Automated Personal Information Collection Devices',
    subtitle:
      "The Company operates automatic data storage and retrieval systems such as cookies. A cookie is a small text file sent by a server that operates the website to your browser, which is stored on your computer's hard disk.",
    desc: '1) Purpose of using cookies\
        \nTo provide personalized and customized services, the Company uses cookies to store and retrieve information about the user. When a user visits a website, the website server reads the cookie content stored on the user’s device, maintaining user settings and providing customized services. Cookies help users access websites according to their preferences, making it easier to use the website. Additionally, cookies are used to provide personalized information, such as optimized advertisements, based on the user’s website visit records and usage patterns.\
        \n2) How to reject cookies\
        \nTo reject cookies, you can choose the option in the app or web browser you use to either allow all cookies, confirm each time a cookie is stored, or reject all cookies.',
  },
  {
    title: '9. Technical and Managerial Measures for the Protection of Personal Information',
    subtitle:
      'The Company takes the following technical and managerial measures to prevent loss, theft, leakage, modification, or damage of personal information.',
    desc: '1) Personal information is protected by passwords, and important data is protected using additional security measures such as file encryption or file lock functions.\
        \n2) The Company installs systems in zones restricted from external access to prevent hacking or computer viruses from leaking or damaging personal information, and utilizes intrusion detection systems and firewalls for 24-hour monitoring.\
        \n3) The Company has criteria for granting, modifying, and deleting access rights to structured databases that process personal information. It regulates password creation methods, changing cycles, and other measures to ensure access control for personal information.\
        \n4) The number of employees who handle personal information is minimized and limited to specific personnel. Regular training on new security technologies and personal information protection obligations is conducted, and specific passwords are provided to manage access rights.\
        \n5) IDs and passwords used by users are for the exclusive use of users. The Company is not responsible for problems arising from individual negligence in managing IDs, passwords, or emails, or from inherent risks of the internet.',
  },
  {
    title: '10. Personal Information Manager and Contact Information',
    subtitle:
      "Users can report any personal information protection-related complaints arising from the Company's service to the personal information manager or the relevant department.",
    desc: 'Personal Information Manager\
        \n- Name: Junhye Park\
        \n- Position: CEO\
        \n- Contact: contact@hellowoot.co.kr',
  },
  {
    title: '11. Revisions and Notification of the Privacy Policy',
    subtitle:
      'Woot may modify the privacy policy to reflect changes in laws or services. If the privacy policy changes, Woot will post the changes, and the revised privacy policy will take effect 7 days after posting.',
    desc: 'Announcement Date: July 18, 2022\
        \nEffective Date: July 25, 2022',
  },
]

export const personalDataZh = [
  {
    title: '第1條（收集的個人信息類型）',
    subtitle:
      '會員可以選擇註冊成為會員並使用服務。在此情況下，公司從會員註冊時起收集以下某些個人信息。然而，如果會員不屬於每個項目，則該項目的個人信息將永不被收集。',
    desc: `
    \n1) 使用蘋果或谷歌帳戶註冊（必需）\
    \n- 帳戶用戶名\
    \n2) 使用蘋果或谷歌帳戶註冊（可選）\
    \n- 電子郵件地址\
    \n3) 回答性格類型測驗\
    \n- 針對測驗回答的會員，所有測驗回答結果\
    \n4) 註冊額外測驗\
    \n- 額外測驗問題，額外測驗回答\
    \n5) 鏈接KakaoTalk朋友\
    \n- 我關注的朋友\
    \n6) 請求附屬/合作或發帖\
    \n- 群組名稱、姓名、職位、電子郵件、聯絡號碼\
    \n7) 服務使用期間自動收集的信息\
    \n- IP地址、cookies、訪問日期、服務使用記錄、不當行為記錄、設備信息、ADID、IDFA\
    \n※ 通過會員支持流程或單獨的通知窗口可能需要收集的每個項目或額外項目的個人信息可能在服務期間被收集。\
    \n※ 公司絕不收集種族、意識形態或醫療信息等敏感信息。\
    \n※ 個人信息可能由與公司有關聯的外部公司或組織提供，在這種情況下，收集是在聯營獲得用戶同意後進行的。\
    `,
  },
  {
    title: '2. 收集與使用個人信息的目的',
    subtitle: '為了提供愉快的服務，公司僅出於以下目的使用個人信息：',
    desc: '1) 會員身份識別，確認加入和退出的意圖，防止濫用和重複註冊，會員管理\
        \n2) 開發、提供和改進個性化推薦服務，如“測驗結果排名”和“化學相容的推薦朋友"\
        \n3) 處理會員查詢/建議/附屬/合作/發帖請求，傳遞公告\
        \n4) 在新服務開發和市場營銷、廣告中的利用\
        \n5) 協助會員找到他們可能認識的其他會員\
        \n6) 履行公司與會員之間的協議',
  },
  {
    title: '3. 個人信息的收集方',
    subtitle: '公司通過應用程序、網絡服務、參與活動、來自聯營公司的信息轉移和交易過程收集個人信息。.',
    desc: '',
  },
  {
    title: '4. 個人信息的保留和使用期限',
    subtitle: '一旦實現收集和使用個人信息的目的，用戶的個人信息將被迅速銷毀。然而，以下信息因下述原因保留指定期限：',
    desc: '1) 基於公司內部政策的信息保留原因\
        \n- 保留項目：不當行為記錄\
        \n- 保留原因：防止不當行為\
        \n- 保留期限：5年\
        \n- 保留項目：已退出會員的個人信息\
        \n- 保留原因：防止重新註冊的濫用，協助權利侵犯糾紛和調查\
        \n- 保留期限：1年\
        \n ※ 對於違反服務規則的用戶，例如洩露社區帖子或分享ID，防止重新註冊和服務限制，電話號碼和電子郵件將被匿名化並存儲最多5年。\
        \n2) 基於相關法律的信息保留原因\
        \n- 保留項目：支付和供應商品等的記錄\
        \n- 法律依據：電子商務消費者保護法等\
        \n- 保留期限：5年\
        \n保留項目：合同或訂閱撤回等的記錄\
        \n- 法律依據：電子商務消費者保護法等\
        \n- 保留期限：5年\
        \n保留項目：消費者投訴或爭議解決的記錄\
        \n- 法律依據：電子商務消費者保護法等\
        \n- 保留期限：3年\
        \n保留項目：支付和供應商品等的相關記錄\
        \n- 法律依據：電子商務消費者保護法等\
        \n- 保留期限：5年\
        \n保留項目：身份驗證記錄\
        \n- 法律依據：信息通信網利用和信息保護法\
        \n- 保留期限：6個月\
        \n保留項目：訪問記錄\
        \n- 法律依據：通信秘密保護法\
        \n- 保留期限：3個月',
  },
  {
    title: '5. 個人信息銷毀程序和方法',
    subtitle:
      '旦實現收集和使用個人信息的目的，公司將迅速銷毀相關信息。紙質的個人信息使用碎紙機切碎或焚燒，而存儲在電子文件格式的個人信息使用技術方法刪除，使得記錄無法再生。(去標識化信息是單向加密信息，無法解密，且無人能從此信息識別或推斷個體。',
    desc: '',
  },
  {
    title: '6. 個人信息的提供和共享',
    subtitle: '除非用戶在服務使用過程中另行同意或法律規定，公司不提供或共享用戶個人信息超出上述範圍。',
    desc: '',
  },
  {
    title: '7. 用戶和法定代表人的權利、義務和行使權利的方法',
    subtitle:
      '用戶可以隨時訪問或修改他們的個人信息，也可以要求撤回同意或終止會員資格。具體來說，對於變更或會員終止（撤回同意），用戶可以在服務中點擊“帳戶刪除”，或如果通過電子郵件或單獨公告板聯繫管理員，將迅速採取適當措施。',
    desc: '',
  },
  {
    title: '8. 個人信息自動收集裝置的安裝、運行和拒絕',
    subtitle:
      '公司運營‘cookies’和其他類似技術，自動存儲和檢索用戶信息。Cookies是由運營網站的服務器發送到用戶的瀏覽器的非常小的文本文件，並存儲在用戶的計算機硬盤上。',
    desc: '1) 使用cookies的目的 我們使用cookies來存儲和檢索用戶信息，以提供個性化和定制化服務。當用戶訪問網站時，網站服務器讀取存儲在用戶設備上的cookies的內容，以維持用戶設置並提供定制化服務。\
    Cookies幫助用戶根據他們的設置方便地訪問和使用網站。此外，它們被用來提供基於用戶網站訪問歷史和使用模式的優化廣告和個性化信息。\
        \n2) 拒絕cookie設置的方法 用戶可以通過選擇他們使用的應用程序或網絡瀏覽器中的選項來拒絕cookie設置，\
        以允許所有cookies、提示每個cookie存儲的確認或拒絕所有cookie存儲。',
  },
  {
    title: '9. 個人信息保護的技術和行政措施',
    subtitle: '公司實施以下技術和行政措施，以確保用戶個人信息的安全，防止其丟失、盜竊、洩漏、更改或損壞：',
    desc: '1) 用戶個人信息通過密碼保護，重要數據進一步通過加密文件和傳輸數據或文件鎖定等安全功能加以保護。\
        \n2) 公司在外部訪問受控的區域安裝系統，使用入侵防範設備和入侵檢測系統，全天候監控和控制訪問，以防止用戶個人信息因黑客攻擊或計算機病毒而洩漏或損壞。\
        \n3) 公司制定授予、更改和撤銷處理個人信息的數據庫訪問權限的標準，並運營密碼生成和更改周期的指導方針，採取必要措施進行其他個人信息的訪問控制。\
        \n4) 處理個人信息的員工限於指定人員，並定期接受新安全技術獲取和個人信息保護義務的教育。他們還通過單獨的密碼進行訪問控制來進行管理。\
        \n5) 用戶使用的ID和密碼僅供用戶使用。公司對由於用戶個人疏忽導致ID、密碼、電子郵件或其他個人信息洩漏或由於互聯網基本使用而固有的風險所造成的問題不承擔責任。',
  },
  {
    title: '10. 個人資料管理負責人及聯絡資訊',
    subtitle:
      '用戶可以向個人信息管理負責人或相關部門報告在使用公司服務時產生的所有個人信息保護相關投訴。 個人信息管理負責人：',
    desc: '\n- 名稱: Lee dong hwan\
        \n- 職位: CTO\
        \n- 聯絡方式: contact@hellowoot.co.kr',
  },
  {
    title: '11. 隱私政策的修訂和通知',
    subtitle:
      'Ute可能會修訂隱私政策，以反映法律或服務的變更。當隱私政策發生變更時，Ute將張貼變更內容，並在張貼日期後7天生效。',
    desc: '公告日期：2022年7月11日\
        \n生效日期：2022年7月18日',
  },
]

export const personalDataJa = [
  {
    title: '1. 収集する個人情報の種類',
    subtitle:
      '会員は会員登録を行い、サービスを利用することができます。この場合、会員登録時から次の一部の個人情報を収集します。ただし、会員が各項目に該当しない場合、その個人情報は収集されません。',
    desc: '1) AppleまたはGoogleアカウントでの登録時（必須）\
        \n- アカウントユーザー名\
        \n2) AppleまたはGoogleアカウントでの登録時（任意）\
        \n- メールアドレス\
        \n3) 性格タイプクイズに回答する際\
        \n- クイズ回答対象の会員、全クイズ回答結果\
        \n4) 追加のクイズを登録する際\
        \n- 追加のクイズ質問、追加のクイズ回答\
        \n5) カカオトークの友達を連携する際\
        \n- 私がフォローしている友達\
        \n6) 所属/協業の要請または投稿する際\
        \n- グループ名、氏名、役職、メール、連絡先番号\
        \n7) サービス利用中に自動で収集される情報\
        \n- IPアドレス、クッキー、訪問日、サービス利用記録、不正記録、デバイス情報、ADID、IDFA\
        \n※ 各項目や追加で収集が必要な場合、別途通知画面を通じて収集されることもあります。\
        \n※ 人種、思想、医療情報等の敏感情報は一切収集しません。\
        \n※ 外部企業や会社と提携する場合、提携先がユーザーから同意を得た後に収集されます。',
  },
  {
    title: '2. 個人情報収集・利用の目的',
    subtitle: '快適なサービスを提供するために、個人情報を次の目的のみに使用します。',
    desc: '1) 会員の識別、入退会の意思確認、悪用・重複登録の防止、会員管理\
        \n2) 「クイズ結果ランキング」や「ケミストリーのあるおすすめ友達」などのパーソナライズされた推薦サービスの開発、提供、改善\
        \n3) 会員の問い合わせ/提案/所属/協業/投稿依頼の処理、告知の伝達\
        \n4) 新しいサービスの開発・マーケティング・広告への活用\
        \n5) 知り合いの会員を見つける際の支援\
        \n6) 会社と会員間の合意履行',
  },
  {
    title: '3. 個人情報の収集方法',
    subtitle:
      'アプリケーション、ウェブサービス、イベント参加、提携企業からの情報提供、取引過程を通じて個人情報を収集します。',
    desc: '',
  },
  {
    title: '4. 個人情報の保有・利用期間',
    subtitle:
      '個人情報の収集および利用目的が達成された後、直ちに破棄します。ただし、以下の情報は指定の期間、以下の理由で保持されます。',
    desc: '1) 社内方針に基づく情報保持理由\
        \n保持項目: 不正記録\
        \n- 保持理由: 不正防止\
        \n- 保持期間: 5年\
        \n保持項目: 退会会員の個人情報\
        \n- 保持理由: 再登録の悪用防止、権利侵害紛争及び調査への協力\
        \n- 保持期間: 1年\
        \n※ サービス規則違反者については、コミュニティ情報漏洩やID、電話番号、メール共有の場合、最大5年間議論し、再登録及びサービス制限を防止します。\
        \n2) 関連法令に基づく情報保持理由\
        \n保持項目: 支払及び物品供給記録など\
        \n- 法的根拠: 電子商取引における消費者保護に関する法律\
        \n- 保持期間: 5年\
        \n保持項目: 契約または加入撤回等の記録\
        \n- 法的根拠: 電子商取引における消費者保護に関する法律\
        \n- 保持期間: 5年\
        \n保持項目: 消費者苦情または紛争処理の記録\
        \n- 法的根拠: 電子商取引における消費者保護に関する法律\
        \n- 保持期間: 3年\
        \n保持項目: 支払及び物品供給に関する記録\
        \n- 法的根拠: 電子商取引における消費者保護に関する法律\
        \n- 保持期間: 5年\
        \n保持項目: 身元確認の記録\
        \n- 法的根拠: 情報通信網の利用促進及び情報保護に関する法律\
        \n- 保持期間: 6ヶ月\
        \n保持項目: 訪問記録\
        \n- 法的根拠: 通信秘密保護法\
        \n- 保持期間: 3ヶ月',
  },
  {
    title: '5. 個人情報の破棄手続きと方法',
    subtitle:
      '個人情報の収集・利用目的が達成された後、関連情報を直ちに破棄します。紙に印刷された個人情報はシュレッダーで裁断・焼却し、電子ファイル形式で保存された個人情報は記録を再生できない技術的方法で削除します。（無識別情報は一方向に暗号化され、誰も解読できず、個人を特定または推測できません。）',
    desc: '',
  },
  {
    title: '6. 個人情報の提供及び共有',
    subtitle:
      'サービス利用過程でユーザーが別途同意した場合や法令で定められた場合を除き、個人情報を上記範囲を超えて提供・共有することはありません。',
    desc: '',
  },
  {
    title: '7. ユーザー及び法定代理人の権利、義務、行使方法',
    subtitle:
      'ユーザーは自身の個人情報の閲覧、修正がいつでも可能です。また、同意撤回や会員脱退（退会）を要請できます。特に、変更や会員脱退（同意撤回）の場合、「アカウント削除」をクリックするか、管理者にメールや掲示板を通じて連絡すると、適した措置を迅速に行います。',
    desc: '',
  },
  {
    title: '8. 自動化された個人情報収集デバイスの設置、運営、拒否に関する事項',
    subtitle:
      '当社では、Cookieなどの自動データストレージと取得システムを運営しています。Cookieは、ウェブサイトを運営するサーバーがブラウザに送信する小さなテキストファイルで、コンピュータのハードディスクに保存されます。',
    desc: '1) クッキー使用の目的\
        \nカスタマイズされたサービスを提供するためにクッキーを利用し、ユーザーに関する情報を保存・取得します。ユーザーがウェブサイトを訪問すると、サーバーがユーザーのデバイスに保存されたクッキーを読み取り、ユーザー設定を維持し、カスタマイズされたサービスを提供します。クッキーはユーザーがウェブサイトを利用しやすくするために役立ちます。また、クッキーはユーザーのサイト訪問記録、利用パターンに基づく個別情報、最適化された広告を提供します。\
        \n2) クッキーの拒否方法\
        \nクッキーを拒否するために、使用するアプリやウェブブラウザ内で、すべてのクッキーを受け入れる、クッキーが保存されるたびに確認する、すべてのクッキーを拒否する、のオプションを選択できます。',
  },
  {
    title: '9. 個人情報保護のための技術的及び管理的措置',
    subtitle: '個人情報の紛失、盗難、流出、改ざん、損傷を防止するため、技術的及び管理的な措置を講じています。',
    desc: '1) 個人情報はパスワードで保護され、重要なデータはファイル暗号化やファイルロック機能などの追加的なセキュリティを使用して保護されています。\
        \n2) 当社では、個人情報の漏洩や破損を防ぐために、外部アクセス制限ゾーンにシステムを設置し、侵入検知システムやファイアウォールを活用して24時間監視しています。\
        \n3) 構造化データベースのアクセス権の付与、変更、削除に関する基準があります。パスワード設定方法、変更周期などを規定し、個人情報へのアクセス制御を適切に行います。\
        \n4) 個人情報を取り扱う従業員の数を最小限にし、特定の人員に限定しています。定期的に新たなセキュリティ技術や個人情報保護義務に関するトレーニングを行い、アクセス権管理用の特定のパスワードを提供します。\
        \n5) ユーザーが使用するIDとパスワードはユーザー専用です。当社はID、パスワード、メールの管理における個人の過失やインターネットの本質的なリスクによる問題に責任を负いません。',
  },
  {
    title: '10. 個人情報管理者及び連絡先',
    subtitle: '当社のサービスにより発生した個人情報保護関連の苦情を個人情報管理者や関連部門に報告できます。',
    desc: '個人情報管理者\
        \n- 氏名: Junhye Park\
        \n- 職位: CEO\
        \n- 連絡先: contact@hellowoot.co.kr',
  },
  {
    title: '11. 個人情報保護方針の改定及び通知',
    subtitle:
      'Wootは、法令やサービスの変更を反映するために個人情報保護方針を改定することがあります。方針の変更があった場合、Wootは変更を掲示し、改訂された方針は掲示後7日後に発効します。',
    desc: '告知日: 2022年7月18日\
        \n施行日: 2022年7月25日',
  },
]

export const service: { [key in LocaleCode]: { title: string; desc: string }[] } = {
  ko: serviceKo,
  en: serviceEn,
  zhHant: serviceZh,
  ja: serviceJa,
}

export const personalData: { [key in LocaleCode]: { title: string; subtitle: string; desc: string }[] } = {
  ko: personalDataKo,
  en: personalDataEn,
  zhHant: personalDataZh,
  ja: personalDataJa,
}
